import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from '../../services/router-utils';
import { fetchUser } from '../../actions/fetch-user';
import { fetchUserAndRedirect } from '../../actions/fetch-user-and-redirect';
import fetchPostsByOwnerId from '../../actions/fetch-posts-by-owner-id';
import { redirectTo404 } from '../../actions/redirect-to-404';
import { setIsLoaded } from '../../actions/set-is-loaded';
import PostList from '../../components/post-list';
import NoUserPosts from '../../components/no-user-posts';
import { getIsProfilePostsLoading } from '../../selectors/is-loading-selectors';
import { getIsProfilePostsLoaded } from '../../selectors/is-loaded-selectors';
import { getEntityCount } from '../../selectors/pagination-selectors';
import { getSortedPostsByOwnerId, getPostsByOwnerIdAndPage } from '../../selectors/post-selectors';
import { getUserBySlug } from '../../selectors/user-selectors';
import { POSTS_PER_PAGE } from '../../constants/pagination';

export class ProfilePosts extends Component {
  static fetchData = ({ store, params, query, search }) =>
    store
      .dispatch(fetchUserAndRedirect(params.userSlug, search))
      .then(user =>
        store.dispatch(
          fetchPostsByOwnerId({
            ownerId: user._id,
            page: _.toNumber(query.page) || 1,
            pageSize: POSTS_PER_PAGE,
          })
        )
      )
      .catch(() => store.dispatch(redirectTo404(search)));

  componentDidMount = () => {
    this.fetchUserData(this.props.params.userSlug);
  };

  componentWillReceiveProps = ({ params: nextParams }) => {
    const { params: { userSlug } } = this.props;

    if (userSlug !== nextParams.userSlug) {
      this.fetchUserData(nextParams.userSlug);
    }
  };

  componentWillUnmount = () => {
    this.props.setIsLoaded('profile-posts', this.props.userId, false);
  };

  fetchUserData = userSlug => this.props.fetchUser(userSlug).then(({ _id }) => this.fetchPosts(_id));

  fetchPosts = (ownerId, page = this.getPage()) =>
    this.props.fetchPosts({
      ownerId,
      page,
      pageSize: POSTS_PER_PAGE,
    });

  getPage = () => _.toNumber(this.props.location.query.page) || 1;
  changePage = page => {
    const { userId } = this.props;
    this.fetchPosts(userId, _.toNumber(page));
    this.props.push({ pathname: `/profiles/${this.props.params.userSlug}`, query: { page } });
  };
  loadMore = page => this.fetchPosts(this.props.userId, page);

  render = () => {
    const {
      entityCount,
      allPosts,
      currentPagePosts,
      incrementPostLikeCount,
      isProfilePostsLoading,
      isProfilePostsLoaded,
    } = this.props;

    if (!allPosts.length) {
      return <NoUserPosts/>;
    }

    return (
      <PostList
        page={this.getPage()}
        entityCount={entityCount}
        allPosts={allPosts}
        currentPagePosts={currentPagePosts}
        changePage={this.changePage}
        loadMore={this.loadMore}
        isLoading={isProfilePostsLoading}
        isLoaded={isProfilePostsLoaded}
        onLikeClick={incrementPostLikeCount}
        hasSpacing={false}
      />
    );
  };
}

ProfilePosts.propTypes = {
  fetchUser: PropTypes.func.isRequired,
  fetchPosts: PropTypes.func.isRequired,
  setIsLoaded: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  incrementPostLikeCount: PropTypes.func.isRequired,
  isProfilePostsLoaded: PropTypes.bool.isRequired,
  params: PropTypes.object.isRequired,
  allPosts: PropTypes.array.isRequired,
  currentPagePosts: PropTypes.array.isRequired,
  entityCount: PropTypes.number.isRequired,
  location: PropTypes.object,
  userId: PropTypes.string,
  isProfilePostsLoading: PropTypes.bool.isRequired,
};

ProfilePosts.defaultProps = {
  allPosts: [],
  currentPagePosts: [],
  page: 1,
};

const mapStateToProps = (state, { params: { userSlug }, location: { query: { page } } }) => {
  const user = getUserBySlug(state, userSlug) || {};
  return {
    allPosts: getSortedPostsByOwnerId(state, user._id),
    currentPagePosts: getPostsByOwnerIdAndPage(state, user._id, _.toNumber(page) || 1),
    entityCount: getEntityCount(state, 'posts'),
    userId: user._id,
    isProfilePostsLoading: getIsProfilePostsLoading(state),
    isProfilePostsLoaded: getIsProfilePostsLoaded(state),
  };
};

const mapDispatchToProps = {
  fetchUser,
  fetchPosts: fetchPostsByOwnerId,
  push,
  setIsLoaded,
};

export default _.flowRight(connect(mapStateToProps, mapDispatchToProps))(ProfilePosts);



// WEBPACK FOOTER //
// ./app/containers/profile-posts/profile-posts.js